// Enda sanning för dokumentnumrering.
// Alla Word-exporter, dokumenthuvuden och kort ska läsa numret härifrån
// så att samma nummer aldrig betyder två olika saker.

export interface DocRef {
  docNumber: string;
  title: string;
}

export const DOC_REGISTRY = {
  processoversikt: { docNumber: "00", title: "Processöversikt Bas-P" },
  granskningsoversikt: { docNumber: "00b", title: "Granskningsöversikt" },
  scenario_audit: { docNumber: "00c", title: "Scenariotest" },
  sam_rutin: { docNumber: "01", title: "Rutin – Systematiskt arbetsmiljöarbete" },
  funktionskrav_bruksskede: { docNumber: "02", title: "Funktionskrav bruksskede" },
  skr: { docNumber: "03", title: "Projektförutsättningar och SKR-bedömning" },
  forhandsanmalan: { docNumber: "04", title: "Förhandsanmälan Arbetsmiljöverket" },
  uppdragsbekraftelse: { docNumber: "05", title: "Uppdragsbekräftelse Bas-P/Bas-U" },
  tidplan: { docNumber: "06", title: "Tidplansgranskning" },
  dagslage: { docNumber: "06c", title: "Dagsläge vid datum" },
  tredjeman: { docNumber: "07", title: "Tredje man och pågående verksamhet" },
  farligtmaterial: { docNumber: "08", title: "Farligt material" },
  elsakerhet: { docNumber: "09", title: "Frånkoppling och säkert avställt läge" },
  arbetsomrade: { docNumber: "10", title: "Arbetsområdesutredning" },
  arbetsomrade_samlad: { docNumber: "10b", title: "Samlad arbetsområdesutredning" },
  risksammanstallning_projektering: { docNumber: "11", title: "Risksammanställning projektering" },
  amp: { docNumber: "12", title: "Arbetsmiljöplan" },
  sarskilda_risker: { docNumber: "13", title: "Särskilda arbetsmiljörisker" },
  skyddsregler: { docNumber: "15", title: "Skydds- och ordningsregler" },
  introduktion: { docNumber: "15c", title: "Säkerhetsintroduktion per person" },
  projektorinlamning: { docNumber: "16", title: "Projektörsinlämning – kvarvarande risker" },
  upphandlingskrav: { docNumber: "17", title: "Upphandlingskrav arbetsmiljö" },
  projektorrutin: { docNumber: "18", title: "Projektörens arbetsmiljörutin" },
  projektorintyg: { docNumber: "19", title: "Leveransintyg projektörsansvar" },
  overlamning_basp_basu: { docNumber: "20", title: "Överlämning Bas-P → Bas-U" },
  utforande: { docNumber: "21", title: "Uppföljning av utförandet" },
  overlamning_byggherre: { docNumber: "22", title: "Överlämning till byggherre" },
  samordning: { docNumber: "23", title: "Samordningsmöte Bas-P / Bas-U" },
  arbetsberedning: { docNumber: "24", title: "Arbetsberedning" },
  startbesked_arbetsberedningar: { docNumber: "24b", title: "Startbesked arbetsberedningar" },
  qa_logg: { docNumber: "25", title: "Q&A-logg" },
  skedesplan: { docNumber: "26", title: "Skedesplan och APD-plan" },
  skyddsrond: { docNumber: "27", title: "Skyddsrondsprotokoll" },
  tillbud: { docNumber: "28", title: "Tillbud- och olycksrapportering" },
  slutkontroll: { docNumber: "30", title: "Slutkontroll arbetsmiljö" },
  risksammanstallning_utforande: { docNumber: "30b", title: "Risksammanställning utförande" },
  risksammanstallning_samordnad: { docNumber: "30c", title: "Samordnad risksammanställning" },
  risksammanstallning_bruksskede: { docNumber: "31", title: "Kvarvarande bruksrisker" },
  overlamning_forvaltning: { docNumber: "32", title: "Överlämning till förvaltning" },
  uppfoljning_bruksskede: { docNumber: "33", title: "Uppföljning bruksskede" },
  overlamningssammanfattning: { docNumber: "34", title: "Överlämningssammanfattning inför bruksskede" },
  basu_rutin: { docNumber: "40", title: "Rutin Bas-U" },
  basu_checklista: { docNumber: "41", title: "Checklista Bas-U" },
  skyddsverksamhet: { docNumber: "42", title: "Plan för skyddsverksamhet" },
  platsnarvaro: { docNumber: "43", title: "Platsnärvaro Bas-U" },
  tillfalliga_konstruktioner: { docNumber: "44", title: "Tillfälliga och samverkande konstruktioner" },
  toolbox_talk: { docNumber: "45", title: "Toolbox talk – arbetsmiljödialog" },
  disciplinara_atgarder: { docNumber: "46", title: "Disciplinära åtgärder" },
} as const satisfies Record<string, DocRef>;

export type DocKey = keyof typeof DOC_REGISTRY;

export const docNumberFor = (key: DocKey): string => DOC_REGISTRY[key].docNumber;
export const docTitleFor = (key: DocKey): string => DOC_REGISTRY[key].title;
/** "Dok 24" – för etiketter i gränssnittet. */
export const docLabel = (key: DocKey): string => `Dok ${DOC_REGISTRY[key].docNumber}`;
